/* requires:
polyfill.js
*/

const findCourseForm = {
  init: function (formId) {
    const theForm = document.getElementById(formId);

    this.validateOnBlur(theForm);
    this.populateStates(theForm);

    // listening for click on the submit button
    const submitBtn = theForm.querySelector('button[type="submit"]');
    submitBtn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        const isFormValid = findCourseForm.isFormValid(theForm);
        if (!isFormValid) {
          alert('Please select your state and choose a course type.');
          return false;
        } else {
          window.location = theForm.action;
        }
      },
      true
    );
  },

  populateStates: function (theForm) {
    const stateSelect = theForm.querySelector('[name="state"]');
    const categorySelect = theForm.querySelector('[name="category"]');

    // populate state dropdown
    let states = '<option value="" selected="selected" disabled="disabled">Select State</option>';
    for (let key of Object.keys(coursesMap)) {
      states = states + `<option value="${key}">${key}</option>`;
    }
    stateSelect.innerHTML = states;

    // listen for change events on the state dropdown
    stateSelect.addEventListener('change', function () {
      // console.log(this.value);
      categorySelect.disabled = false;
      findCourseForm.populateCategories(theForm, this.value);
    });
  },

  populateCategories: function (theForm, state) {
    const categorySelect = theForm.querySelector('[name="category"]');
    const categories = coursesMap[state];
    let categoryOptions = '<option value="" selected="selected" disabled="disabled">Select Course Type</option>';

    // populate category dropdown
    for (let [key, value] of Object.entries(categories)) {
      if (value) {
        categoryOptions = categoryOptions + `<option value="${key}">${key}</option>`;
      }
    }
    categorySelect.innerHTML = categoryOptions;

    // listen for change events on the state dropdown
    categorySelect.addEventListener('change', function () {
      // console.log(this.value);
      // update the form's action with the url
      theForm.action = categories[this.value];
    });
  },

  validateOnBlur: function (theForm) {
    if (!theForm) return false;

    // realtime form fields validation using blur event
    const fields = theForm.querySelectorAll('.required');
    for (let field of fields) {
      field.addEventListener(
        'blur',
        function (e) {
          const x = field.value;
          if (!x || x.trim() == '') {
            field.classList.add('is-invalid');
          } else {
            field.classList.remove('is-invalid');
          }
        },
        true
      );
    }
  },

  isFormValid: function (theForm) {
    if (!theForm) return false;

    // form fields validation during submission
    const fields = theForm.querySelectorAll('.required');
    let isFormValid = true;
    for (let field of fields) {
      const x = field.value;
      if (!x || x.trim() == '') {
        field.classList.add('is-invalid');
        isFormValid = false;
      } else {
        field.classList.remove('is-invalid');
      }
    }
    return isFormValid;
  },
};

const coursesMap = {
  ['Alabama']: {
    ['Alarm Technician Continuing Education']: '/continuing-education/license-renewal/al-alarm/',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/al-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/alabama/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Alaska']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ak-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/alaska/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Arizona']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/arizona/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Arkansas']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ar-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/arkansas/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['California']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ca-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/california/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Colorado']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/co-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/colorado/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Connecticut']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ct-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/connecticut/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Delaware']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/de-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/delaware/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['District of Columbia']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/d-c/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Florida']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/fl-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/florida/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Georgia']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ga-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/georgia/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Hawaii']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/hawaii/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Idaho']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/id-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/idaho/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Illinois']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/illinois/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Indiana']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/indiana/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Iowa']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ia-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/iowa/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Kansas']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ks-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/kansas/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Kentucky']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ky-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/kentucky/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Louisiana']: {
    ['Alarm Technician Continuing Education']: '/continuing-education/license-renewal/la-alarm/',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/louisiana/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Maine']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/me-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/maine/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Maryland']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/md-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/maryland/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Massachusetts']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ma-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/massachusetts/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Michigan']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/mi-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/michigan/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Minnesota']: {
    ['Alarm Technician Continuing Education']: '/continuing-education/license-renewal/ms-alarm/',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/mn-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/minnesota/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Mississippi']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/mississippi/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Missouri']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/missouri/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Montana']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/mt-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/montana/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Nebraska']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ne-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/nebraska/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Nevada']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/nv-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/nevada/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['New Hampshire']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Apprentice']: '/continuing-education/license-renewal/nh-apprentice/',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/nh-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/new-hampshire/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['New Jersey']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/nj-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/new-jersey/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['New Mexico']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/nm-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/new-mexico/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['New York']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education (City of Troy)']: '/continuing-education/license-renewal/ny-t-electrical/',
    ['Electrical Continuing Education (Suffolk County)']: '/continuing-education/license-renewal/ny-s-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/new-york/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['North Carolina']: {
    ['Alarm Technician Continuing Education']: '/continuing-education/license-renewal/nc-alarm/',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/nc-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/north-carolina/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
    ['Security and PI License']: '/continuing-education/license-renewal/nc-security/',
  },
  ['North Dakota']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/nd-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/north-dakota/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Ohio']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/oh-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/ohio/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Oklahoma']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ok-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/oklahoma/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Oregon']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/or-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/oregon/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Pennsylvania']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/pa-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/pennsylvania/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Rhode Island']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ri-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/rhode-island/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['South Carolina']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/south-carolina/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['South Dakota']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/sd-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/south-dakota/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Tennessee']: {
    ['Alarm Technician Continuing Education']: '/continuing-education/license-renewal/tn-alarm/',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/tennessee/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Texas']: {
    ['Alarm Technician Continuing Education']: '/continuing-education/license-renewal/tx-alarm/',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/tx-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/texas/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Utah']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/ut-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/utah/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Vermont']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/vt-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/vermont/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Virginia']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/va-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/virginia/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Washington']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/wa-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/washington/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['West Virginia']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '',
    ['Electrical Exam Prep']: '/exam-prep/west-virginia/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Wisconsin']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/wi-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/wisconsin/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
  ['Wyoming']: {
    ['Alarm Technician Continuing Education']: '',
    ['Electrical Continuing Education']: '/continuing-education/license-renewal/wy-electrical/',
    ['Electrical Exam Prep']: '/exam-prep/wyoming/',
    ['Electrical Inspector Continuing Education']: '/continuing-education/license-renewal/icc-inspector/',
  },
};
